import { tokens } from "../theme";

export const mockDataTeam = [
  {
    id: 1,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    age: 35,
    phone: "(665)121-5454",
    access: "admin",
  },
  {
    id: 2,
    name: "Cersei Lannister",
    email: "cerseilannister@gmail.com",
    age: 42,
    phone: "(421)314-2288",
    access: "manager",
  },
  {
    id: 3,
    name: "Jaime Lannister",
    email: "jaimelannister@gmail.com",
    age: 45,
    phone: "(422)982-6739",
    access: "user",
  },
  {
    id: 4,
    name: "Anya Stark",
    email: "anyastark@gmail.com",
    age: 16,
    phone: "(921)425-6742",
    access: "admin",
  },
  {
    id: 5,
    name: "Daenerys Targaryen",
    email: "daenerystargaryen@gmail.com",
    age: 31,
    phone: "(421)445-1189",
    access: "user",
  },
  {
    id: 6,
    name: "Ever Melisandre",
    email: "evermelisandre@gmail.com",
    age: 150,
    phone: "(232)545-6483",
    access: "manager",
  },
  {
    id: 7,
    name: "Ferrara Clifford",
    email: "ferraraclifford@gmail.com",
    age: 44,
    phone: "(543)124-0123",
    access: "user",
  },
  {
    id: 8,
    name: "Rossini Frances",
    email: "rossinifrances@gmail.com",
    age: 36,
    phone: "(222)444-5555",
    access: "user",
  },
  {
    id: 9,
    name: "Harvey Roxie",
    email: "harveyroxie@gmail.com",
    age: 65,
    phone: "(444)555-6239",
    access: "admin",
  },
];

export const mockDataContacts = [
  {
    id: 1,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    age: 35,
    phone: "(665)121-5454",
    address: "0912 Won Street, Alabama, SY 10001",
    city: "New York",
    zipCode: "10001",
    registrarId: 123512,
  },
  {
    id: 2,
    name: "Cersei Lannister",
    email: "cerseilannister@gmail.com",
    age: 42,
    phone: "(421)314-2288",
    address: "1234 Main Street, New York, NY 10001",
    city: "New York",
    zipCode: "13151",
    registrarId: 123512,
  },
  {
    id: 3,
    name: "Jaime Lannister",
    email: "jaimelannister@gmail.com",
    age: 45,
    phone: "(422)982-6739",
    address: "3333 Want Blvd, Estanza, NAY 42125",
    city: "New York",
    zipCode: "87281",
    registrarId: 4132513,
  },
  {
    id: 4,
    name: "Anya Stark",
    email: "anyastark@gmail.com",
    age: 16,
    phone: "(921)425-6742",
    address: "1514 Main Street, New York, NY 22298",
    city: "New York",
    zipCode: "15551",
    registrarId: 123512,
  },
  {
    id: 5,
    name: "Daenerys Targaryen",
    email: "daenerystargaryen@gmail.com",
    age: 31,
    phone: "(421)445-1189",
    address: "11122 Welping Ave, Tenting, CD 21321",
    city: "Tenting",
    zipCode: "14215",
    registrarId: 123512,
  },
  {
    id: 6,
    name: "Ever Melisandre",
    email: "evermelisandre@gmail.com",
    age: 150,
    phone: "(232)545-6483",
    address: "1234 Canvile Street, Esvazark, NY 10001",
    city: "Esvazark",
    zipCode: "10001",
    registrarId: 123512,
  },
  {
    id: 7,
    name: "Ferrara Clifford",
    email: "ferraraclifford@gmail.com",
    age: 44,
    phone: "(543)124-0123",
    address: "22215 Super Street, Everting, ZO 515234",
    city: "Evertin",
    zipCode: "51523",
    registrarId: 123512,
  },
  {
    id: 8,
    name: "Rossini Frances",
    email: "rossinifrances@gmail.com",
    age: 36,
    phone: "(222)444-5555",
    address: "4123 Ever Blvd, Wentington, AD 142213",
    city: "Esteras",
    zipCode: "44215",
    registrarId: 512315,
  },
  {
    id: 9,
    name: "Harvey Roxie",
    email: "harveyroxie@gmail.com",
    age: 65,
    phone: "(444)555-6239",
    address: "51234 Avery Street, Cantory, ND 212412",
    city: "Colunza",
    zipCode: "111234",
    registrarId: 928397,
  },
  {
    id: 10,
    name: "Enteri Redack",
    email: "enteriredack@gmail.com",
    age: 42,
    phone: "(222)444-5555",
    address: "4123 Easer Blvd, Wentington, AD 142213",
    city: "Esteras",
    zipCode: "44215",
    registrarId: 533215,
  },
  {
    id: 11,
    name: "Steve Goodman",
    email: "stevegoodmane@gmail.com",
    age: 11,
    phone: "(444)555-6239",
    address: "51234 Fiveton Street, CunFory, ND 212412",
    city: "Colunza",
    zipCode: "1234",
    registrarId: 92197,
  },
];

export const mockDataInvoices = [
  {
    id: 1,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    cost: "21.24",
    phone: "(665)121-5454",
    date: "03/12/2022",
  },
  {
    id: 2,
    name: "Cersei Lannister",
    email: "cerseilannister@gmail.com",
    cost: "1.24",
    phone: "(421)314-2288",
    date: "06/15/2021",
  },
  {
    id: 3,
    name: "Jaime Lannister",
    email: "jaimelannister@gmail.com",
    cost: "11.24",
    phone: "(422)982-6739",
    date: "05/02/2022",
  },
  {
    id: 4,
    name: "Anya Stark",
    email: "anyastark@gmail.com",
    cost: "80.55",
    phone: "(921)425-6742",
    date: "03/21/2022",
  },
  {
    id: 5,
    name: "Daenerys Targaryen",
    email: "daenerystargaryen@gmail.com",
    cost: "1.24",
    phone: "(421)445-1189",
    date: "01/12/2021",
  },
  {
    id: 6,
    name: "Ever Melisandre",
    email: "evermelisandre@gmail.com",
    cost: "63.12",
    phone: "(232)545-6483",
    date: "11/02/2022",
  },
  {
    id: 7,
    name: "Ferrara Clifford",
    email: "ferraraclifford@gmail.com",
    cost: "52.42",
    phone: "(543)124-0123",
    date: "02/11/2022",
  },
  {
    id: 8,
    name: "Rossini Frances",
    email: "rossinifrances@gmail.com",
    cost: "21.24",
    phone: "(222)444-5555",
    date: "05/02/2021",
  },
];

export const mockTransactions = [
  {
    txId: "01e4dsa",
    user: "johndoe",
    date: "2021-09-01",
    cost: "43.95",
  },
  {
    txId: "0315dsaa",
    user: "jackdower",
    date: "2022-04-01",
    cost: "133.45",
  },
  {
    txId: "01e4dsa",
    user: "aberdohnny",
    date: "2021-09-01",
    cost: "43.95",
  },
  {
    txId: "51034szv",
    user: "goodmanave",
    date: "2022-11-05",
    cost: "200.95",
  },
  {
    txId: "0a123sb",
    user: "stevebower",
    date: "2022-11-02",
    cost: "13.55",
  },
  {
    txId: "01e4dsa",
    user: "aberdohnny",
    date: "2021-09-01",
    cost: "43.95",
  },
  {
    txId: "120s51a",
    user: "wootzifer",
    date: "2019-04-15",
    cost: "24.20",
  },
  {
    txId: "0315dsaa",
    user: "jackdower",
    date: "2022-04-01",
    cost: "133.45",
  },
];

export const mockBarData = [
  {
    country: "AD",
    "hot dog": 137,
    "hot dogColor": "hsl(229, 70%, 50%)",
    burger: 96,
    burgerColor: "hsl(296, 70%, 50%)",
    kebab: 72,
    kebabColor: "hsl(97, 70%, 50%)",
    donut: 140,
    donutColor: "hsl(340, 70%, 50%)",
  },
  {
    country: "AE",
    "hot dog": 55,
    "hot dogColor": "hsl(307, 70%, 50%)",
    burger: 28,
    burgerColor: "hsl(111, 70%, 50%)",
    kebab: 58,
    kebabColor: "hsl(273, 70%, 50%)",
    donut: 29,
    donutColor: "hsl(275, 70%, 50%)",
  },
  {
    country: "AF",
    "hot dog": 109,
    "hot dogColor": "hsl(72, 70%, 50%)",
    burger: 23,
    burgerColor: "hsl(96, 70%, 50%)",
    kebab: 34,
    kebabColor: "hsl(106, 70%, 50%)",
    donut: 152,
    donutColor: "hsl(256, 70%, 50%)",
  },
  {
    country: "AG",
    "hot dog": 133,
    "hot dogColor": "hsl(257, 70%, 50%)",
    burger: 52,
    burgerColor: "hsl(326, 70%, 50%)",
    kebab: 43,
    kebabColor: "hsl(110, 70%, 50%)",
    donut: 83,
    donutColor: "hsl(9, 70%, 50%)",
  },
  {
    country: "AI",
    "hot dog": 81,
    "hot dogColor": "hsl(190, 70%, 50%)",
    burger: 80,
    burgerColor: "hsl(325, 70%, 50%)",
    kebab: 112,
    kebabColor: "hsl(54, 70%, 50%)",
    donut: 35,
    donutColor: "hsl(285, 70%, 50%)",
  },
  {
    country: "AL",
    "hot dog": 66,
    "hot dogColor": "hsl(208, 70%, 50%)",
    burger: 111,
    burgerColor: "hsl(334, 70%, 50%)",
    kebab: 167,
    kebabColor: "hsl(182, 70%, 50%)",
    donut: 18,
    donutColor: "hsl(76, 70%, 50%)",
  },
  {
    country: "AM",
    "hot dog": 80,
    "hot dogColor": "hsl(87, 70%, 50%)",
    burger: 47,
    burgerColor: "hsl(141, 70%, 50%)",
    kebab: 158,
    kebabColor: "hsl(224, 70%, 50%)",
    donut: 49,
    donutColor: "hsl(274, 70%, 50%)",
  },
];

export const mockPieData = [
  {
    id: "hack",
    label: "hack",
    value: 239,
    color: "hsl(104, 70%, 50%)",
  },
  {
    id: "make",
    label: "make",
    value: 170,
    color: "hsl(162, 70%, 50%)",
  },
  {
    id: "go",
    label: "go",
    value: 322,
    color: "hsl(291, 70%, 50%)",
  },
  {
    id: "lisp",
    label: "lisp",
    value: 503,
    color: "hsl(229, 70%, 50%)",
  },
  {
    id: "scala",
    label: "scala",
    value: 584,
    color: "hsl(344, 70%, 50%)",
  },
];

export const mockLineData = [
  {
    id: "transactions",
    color: tokens("dark").greenAccent[500],
    data: [
      {
        x: "04-04-2023",
        y: 101,
      },
      {
        x: "05-04-2023",
        y: 75,
      },
      {
        x: "06-04-2023",
        y: 36,
      },
      {
        x: "07-04-2023",
        y: 216,
      },
      {
        x: "08-04-2023",
        y: 35,
      },
      {
        x: "09-04-2023",
        y: 236,
      },
      {
        x: "10-04-2023",
        y: 88,
      },
      {
        x: "11-04-2023",
        y: 232,
      },
      {
        x: "12-04-2023",
        y: 281,
      },
      {
        x: "13-04-2023",
        y: 1,
      },
      {
        x: "14-04-2023",
        y: 35,
      },
      {
        x: "15-04-2023",
        y: 14,
      },
    ],
  },
];

export const mockGeographyData = [
  {
    id: "AFG",
    value: 0,
  },
  {
    id: "AGO",
    value: 0,
  },
  {
    id: "ALB",
    value: 0,
  },
  {
    id: "ARE",
    value: 0,
  },
  {
    id: "ARG",
    value: 0,
  },
  {
    id: "ARM",
    value: 0,
  },
  {
    id: "ATA",
    value: 0,
  },
  {
    id: "ATF",
    value: 0,
  },
  {
    id: "AUT",
    value: 0,
  },
  {
    id: "AZE",
    value: 0,
  },
  {
    id: "BDI",
    value: 0,
  },
  {
    id: "BEL",
    value: 0,
  },
  {
    id: "BEN",
    value: 0,
  },
  {
    id: "BFA",
    value: 0,
  },
  {
    id: "BGD",
    value: 0,
  },
  {
    id: "BGR",
    value: 0,
  },
  {
    id: "BHS",
    value: 0,
  },
  {
    id: "BIH",
    value: 0,
  },
  {
    id: "BLR",
    value: 0,
  },
  {
    id: "BLZ",
    value: 0,
  },
  {
    id: "BOL",
    value: 0,
  },
  {
    id: "BRN",
    value: 0,
  },
  {
    id: "BTN",
    value: 0,
  },
  {
    id: "BWA",
    value: 0,
  },
  {
    id: "CAF",
    value: 0,
  },
  {
    id: "CAN",
    value: 0,
  },
  {
    id: "CHE",
    value: 0,
  },
  {
    id: "CHL",
    value: 0,
  },
  {
    id: "CHN",
    value: 0,
  },
  {
    id: "CIV",
    value: 0,
  },
  {
    id: "CMR",
    value: 0,
  },
  {
    id: "COG",
    value: 0,
  },
  {
    id: "COL",
    value: 0,
  },
  {
    id: "CRI",
    value: 0,
  },
  {
    id: "CUB",
    value: 0,
  },
  {
    id: "-99",
    value: 0,
  },
  {
    id: "CYP",
    value: 0,
  },
  {
    id: "CZE",
    value: 0,
  },
  {
    id: "DEU",
    value: 0,
  },
  {
    id: "DJI",
    value: 0,
  },
  {
    id: "DNK",
    value: 0,
  },
  {
    id: "DOM",
    value: 0,
  },
  {
    id: "DZA",
    value: 0,
  },
  {
    id: "ECU",
    value: 0,
  },
  {
    id: "EGY",
    value: 0,
  },
  {
    id: "ERI",
    value: 0,
  },
  {
    id: "ESP",
    value: 0,
  },
  {
    id: "EST",
    value: 0,
  },
  {
    id: "ETH",
    value: 0,
  },
  {
    id: "FIN",
    value: 0,
  },
  {
    id: "FJI",
    value: 0,
  },
  {
    id: "FLK",
    value: 0,
  },
  {
    id: "FRA",
    value: 0,
  },
  {
    id: "GAB",
    value: 0,
  },
  {
    id: "GBR",
    value: 0,
  },
  {
    id: "GEO",
    value: 0,
  },
  {
    id: "GHA",
    value: 0,
  },
  {
    id: "GIN",
    value: 0,
  },
  {
    id: "GMB",
    value: 0,
  },
  {
    id: "GNB",
    value: 0,
  },
  {
    id: "GNQ",
    value: 0,
  },
  {
    id: "GRC",
    value: 0,
  },
  {
    id: "GTM",
    value: 0,
  },
  {
    id: "GUY",
    value: 0,
  },
  {
    id: "HND",
    value: 0,
  },
  {
    id: "HRV",
    value: 0,
  },
  {
    id: "HTI",
    value: 0,
  },
  {
    id: "HUN",
    value: 0,
  },
  {
    id: "IDN",
    value: 0,
  },
  {
    id: "IND",
    value: 100,
  },
  {
    id: "IRL",
    value: 0,
  },
  {
    id: "IRN",
    value: 0,
  },
  {
    id: "IRQ",
    value: 0,
  },
  {
    id: "ISL",
    value: 0,
  },
  {
    id: "ISR",
    value: 0,
  },
  {
    id: "ITA",
    value: 0,
  },
  {
    id: "JAM",
    value: 0,
  },
  {
    id: "JOR",
    value: 0,
  },
  {
    id: "JPN",
    value: 0,
  },
  {
    id: "KAZ",
    value: 0,
  },
  {
    id: "KEN",
    value: 0,
  },
  {
    id: "KGZ",
    value: 0,
  },
  {
    id: "KHM",
    value: 0,
  },
  {
    id: "OSA",
    value: 0,
  },
  {
    id: "KWT",
    value: 0,
  },
  {
    id: "LAO",
    value: 0,
  },
  {
    id: "LBN",
    value: 0,
  },
  {
    id: "LBR",
    value: 0,
  },
  {
    id: "LBY",
    value: 0,
  },
  {
    id: "LKA",
    value: 0,
  },
  {
    id: "LSO",
    value: 0,
  },
  {
    id: "LTU",
    value: 0,
  },
  {
    id: "LUX",
    value: 0,
  },
  {
    id: "LVA",
    value: 0,
  },
  {
    id: "MAR",
    value: 0,
  },
  {
    id: "MDA",
    value: 0,
  },
  {
    id: "MDG",
    value: 0,
  },
  {
    id: "MEX",
    value: 0,
  },
  {
    id: "MKD",
    value: 0,
  },
  {
    id: "MLI",
    value: 0,
  },
  {
    id: "MMR",
    value: 0,
  },
  {
    id: "MNE",
    value: 0,
  },
  {
    id: "MNG",
    value: 0,
  },
  {
    id: "MOZ",
    value: 0,
  },
  {
    id: "MRT",
    value: 0,
  },
  {
    id: "MWI",
    value: 0,
  },
  {
    id: "MYS",
    value: 0,
  },
  {
    id: "NAM",
    value: 0,
  },
  {
    id: "NCL",
    value: 0,
  },
  {
    id: "NER",
    value: 0,
  },
  {
    id: "NGA",
    value: 0,
  },
  {
    id: "NIC",
    value: 0,
  },
  {
    id: "NLD",
    value: 0,
  },
  {
    id: "NOR",
    value: 0,
  },
  {
    id: "NPL",
    value: 0,
  },
  {
    id: "NZL",
    value: 0,
  },
  {
    id: "OMN",
    value: 0,
  },
  {
    id: "PAK",
    value: 0,
  },
  {
    id: "PAN",
    value: 0,
  },
  {
    id: "PER",
    value: 0,
  },
  {
    id: "PHL",
    value: 0,
  },
  {
    id: "PNG",
    value: 0,
  },
  {
    id: "POL",
    value: 0,
  },
  {
    id: "PRI",
    value: 0,
  },
  {
    id: "PRT",
    value: 0,
  },
  {
    id: "PRY",
    value: 0,
  },
  {
    id: "QAT",
    value: 0,
  },
  {
    id: "ROU",
    value: 0,
  },
  {
    id: "RUS",
    value: 0,
  },
  {
    id: "RWA",
    value: 0,
  },
  {
    id: "ESH",
    value: 0,
  },
  {
    id: "SAU",
    value: 0,
  },
  {
    id: "SDN",
    value: 0,
  },
  {
    id: "SDS",
    value: 0,
  },
  {
    id: "SEN",
    value: 0,
  },
  {
    id: "SLB",
    value: 0,
  },
  {
    id: "SLE",
    value: 0,
  },
  {
    id: "SLV",
    value: 0,
  },
  {
    id: "ABV",
    value: 0,
  },
  {
    id: "SOM",
    value: 0,
  },
  {
    id: "SRB",
    value: 0,
  },
  {
    id: "SUR",
    value: 0,
  },
  {
    id: "SVK",
    value: 0,
  },
  {
    id: "SVN",
    value: 0,
  },
  {
    id: "SWZ",
    value: 0,
  },
  {
    id: "SYR",
    value: 0,
  },
  {
    id: "TCD",
    value: 0,
  },
  {
    id: "TGO",
    value: 0,
  },
  {
    id: "THA",
    value: 0,
  },
  {
    id: "TJK",
    value: 0,
  },
  {
    id: "TKM",
    value: 0,
  },
  {
    id: "TLS",
    value: 0,
  },
  {
    id: "TTO",
    value: 0,
  },
  {
    id: "TUN",
    value: 0,
  },
  {
    id: "TUR",
    value: 0,
  },
  {
    id: "TWN",
    value: 0,
  },
  {
    id: "TZA",
    value: 0,
  },
  {
    id: "UGA",
    value: 0,
  },
  {
    id: "UKR",
    value: 0,
  },
  {
    id: "URY",
    value: 0,
  },
  {
    id: "USA",
    value: 0,
  },
  {
    id: "UZB",
    value: 0,
  },
  {
    id: "VEN",
    value: 0,
  },
  {
    id: "VNM",
    value: 0,
  },
  {
    id: "VUT",
    value: 0,
  },
  {
    id: "PSE",
    value: 0,
  },
  {
    id: "YEM",
    value: 0,
  },
  {
    id: "ZAF",
    value: 0,
  },
  {
    id: "ZMB",
    value: 0,
  },
  {
    id: "ZWE",
    value: 0,
  },
  {
    id: "KOR",
    value: 0,
  },
];
